import { Button } from '@/components/Button';
import { Modal } from '@/components/Modal';
import { Text } from '@/components/Text';
import { useUserStore } from '@/stores/useUserStore';
import i18n from '@/translations/config';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const UpdateUserDelete = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { deleteUser } = useUserStore();

  const handleDeleteUser = async () => {
    await deleteUser(Number(id));
    navigate(`/${i18n.language}/dashboard/users`);
  };

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Text className="text-center font-medium text-sky-800 md:text-left">
        {t('updateUser:delete.title')}
      </Text>
      <Button className="mt-4 w-full bg-danger lg:w-auto" onClick={handleOpen}>
        {t('updateUser:delete.submit')}
      </Button>
      <Modal
        isOpen={isModalOpen}
        onClose={handleClose}
        className="w-auto"
        title={t('updateUser:delete.validation.title')}
      >
        <p className="mb-4">{t('updateUser:delete.validation.description')}</p>
        <div className="mt-4 flex flex-col space-y-3 sm:flex-row sm:justify-end sm:space-x-3 sm:space-y-0">
          <Button onClick={handleClose}>{t('common:cancel')}</Button>
          <Button className="bg-danger" onClick={handleDeleteUser}>
            {t('common:confirm')}
          </Button>
        </div>
      </Modal>
    </>
  );
};
